module.exports = __webpack_public_path__ + "705ed10c4e482691c6a56986c61f35e4.png";